// extracted by css-extract-rspack-plugin
export default {"header":"header-tzEpJ0","dialogTitle":"dialogTitle-GLeJZH","bodyText":"bodyText-WqzAYK","actions":"actions-q3aNX7"};